import { Component } from "react";
import React from "react";
import JobEntity from "../../types/jobEntity.type";

type Props = {
  listItems: JobEntity[];
  onEdit: (job: JobEntity) => void;
  onDelete: (jobId: number) => void;
};

export default class JobList extends Component<Props> {
  render() {
    const listItems = this.props.listItems.map((d) => (
      <tr key={d.id ?? Math.random()}>
        <td scope="row">{d.title ?? "N/A"}</td>
        <td>{d.description ?? "N/A"}</td>
        <td>{d.user_id ?? "N/A"}</td>
        <td>{d.applyer_id ?? "N/A"}</td>
        <td>
          LONG: {d.longitude ?? "N/A"}, LAT: {d.latitude ?? "N/A"}
        </td>
        <td>{d.is_done != null ? d.is_done.toString() : "N/A"}</td>
        <td>{d.createdAt ?? "N/A"}</td>
        <td>{d.updatedAt ?? "N/A"}</td>
        <td>
          <button
            onClick={() => {
              console.log("Edit button clicked for job:", d); // Debug button click
              this.props.onEdit(d);
            }}
            className="btn btn-primary btn-sm"
            disabled={d.id == null}
          >
            Edit
          </button>
        </td>
        <td>
          <button
            onClick={() => {
              console.log("Delete button clicked for job ID:", d.id); // Debug button click
              d.id != null && this.props.onDelete(d.id);
            }}
            className="btn btn-danger btn-sm"
            disabled={d.id == null}
          >
            Delete
          </button>
        </td>
      </tr>
    ));

    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>Adder ID</th>
            <th>Applyer ID</th>
            <th>Coordinates</th>
            <th>Is Done?</th>
            <th>Created</th>
            <th>Updated</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>{listItems}</tbody>
      </table>
    );
  }
}